// ============================================================================
// Contact capture — the conversion step for an advert visitor.
// ============================================================================
// Rendered INSIDE the widget, in the same chrome as the questionnaire that
// precedes it, so the visitor never feels handed off to a different product.
//
// This is the only point on the assessment-first path where contact details are
// asked for. Everything before it was anonymous on purpose; everything after it
// is identical to a chat-first visitor finishing a conversation.
// ============================================================================

import React from 'react';
import {
  Wrapper, StepTitle, StepSubtitle, TextInput, PrimaryBtn, GhostBtn, ErrorText,
} from '../assessments/oinp/ui';
import { translator } from '../assessments/oinp/i18n';

const AssessmentContactCapture = ({
  contact,
  onChange,
  onSubmit,
  onBack,
  sending = false,
  error = '',
  expertName = '',
  darkMode = false,
  scheme = 'blue',
  language = 'en',
}) => {
  const tr = translator(language);

  const submitOnEnter = e => {
    if (e.key === 'Enter' && !sending) onSubmit();
  };

  return (
    <Wrapper>
      <StepTitle $darkMode={darkMode}>{tr('captureTitle')}</StepTitle>
      <StepSubtitle $darkMode={darkMode}>
        {tr('captureBody', { expert: expertName || tr('consultFallbackExpert') })}
      </StepSubtitle>

      <div style={{ marginBottom: 10 }}>
        <TextInput
          $darkMode={darkMode}
          $scheme={scheme}
          value={contact.name}
          placeholder={tr('captureName')}
          onChange={e => onChange({ ...contact, name: e.target.value })}
          onKeyDown={submitOnEnter}
        />
      </div>
      <div style={{ marginBottom: 10 }}>
        <TextInput
          $darkMode={darkMode}
          $scheme={scheme}
          type="email"
          value={contact.email}
          placeholder={tr('captureEmail')}
          onChange={e => onChange({ ...contact, email: e.target.value })}
          onKeyDown={submitOnEnter}
        />
      </div>
      <div style={{ marginBottom: 10 }}>
        <TextInput
          $darkMode={darkMode}
          $scheme={scheme}
          value={contact.phone}
          placeholder={tr('capturePhone')}
          onChange={e => onChange({ ...contact, phone: e.target.value })}
          onKeyDown={submitOnEnter}
        />
      </div>

      {error && <ErrorText>{error}</ErrorText>}

      <PrimaryBtn type="button" $darkMode={darkMode} $scheme={scheme} disabled={sending} onClick={onSubmit}>
        {sending ? tr('captureSending') : tr('captureSubmit')}
      </PrimaryBtn>
      {onBack && (
        <GhostBtn type="button" $darkMode={darkMode} onClick={onBack}>
          {tr('back')}
        </GhostBtn>
      )}
    </Wrapper>
  );
};

export default AssessmentContactCapture;
